module.exports = __webpack_public_path__ + "img/data_ca.b2bad9d6.png";